import axios from 'axios';

const api = {
    // Configuration
    getConfiguration() {
        return axios.get('/api/configuration');
    },

    // Sliders
    getSliders() {
        return axios.get('/api/sliders');
    },

    // Categories
    getCategories() {
        return axios.get('/api/categorias');
    },

    getCategory(id) {
        return axios.get(`/api/categorias/${id}`);
    },

    // Marcas (Brands)
    getMarcas() {
        return axios.get('/api/marcas');
    },

    getMarca(id) {
        return axios.get(`/api/marcas/${id}`);
    },

    // Modelos (Models)
    getModelos() {
        return axios.get('/api/modelos');
    },

    getModelo(id) {
        return axios.get(`/api/modelos/${id}`);
    },

    // Products
    getProducts() {
        return axios.get('/api/productos');
    },

    getProductsByCategory(categoriaId) {
        return axios.get(`/api/productos/categoria/${categoriaId}`);
    },

    getFeaturedProducts() {
        return axios.get('/api/productos-destacados');
    },

    getProduct(id) {
        return axios.get(`/api/productos/${id}`);
    },

    getRelatedProducts(id) {
        return axios.get(`/api/productos/relacionados/${id}`);
    },

    // Videos
    getVideos() {
        return axios.get('/api/videos');
    },

    getFeaturedVideo() {
        return axios.get('/api/videos/destacado');
    },

    getFaqs() {
        return axios.get('/api/faqs');
    },

    getFaqsByCategoria(categoria) {
        return axios.get(`/api/faqs/categoria/${categoria}`);
    },

    getFaqCategorias() {
        return axios.get('/api/faqs/categorias');
    },
    
    // Blogs
    getBlogs() {
        return axios.get('/api/blogs');
    },

    getHomepageBlogs() {
        return axios.get('/api/blogs/inicio');
    },

    getBlog(id) {
        return axios.get(`/api/blogs/${id}`);
    },

    // Obtener blog por slug
    // Intenta primero /api/blogs/slug/{slug}, si falla intenta /api/blogs/{slug}
    async getBlogsBySlug(slug) {
        console.log('🔍 Buscando blog con slug:', slug);
        try {
            // Intenta con ruta específica de slug
            const response = await axios.get(`/api/blogs/slug/${slug}`);
            console.log('✅ Blog encontrado en /api/blogs/slug/' + slug, response.data);
            return response;
        } catch (error) {
            console.log('⚠️ No encontrado en /api/blogs/slug/' + slug + ', intentando /api/blogs/' + slug);
            try {
                // Intenta con ruta directa (mismo formato que getBlog)
                const response = await axios.get(`/api/blogs/${slug}`);
                console.log('✅ Blog encontrado en /api/blogs/' + slug, response.data);
                return response;
            } catch (error2) {
                console.error('❌ Error buscando blog:', error2);
                throw error2;
            }
        }
    },

    // Partners
    getPartners() {
        return axios.get('/api/partners');
    },

    // WhatsApp
    getWhatsappAgents() {
        return axios.get('/api/whatsapp-agents');
    },

    // Contact
    sendContact(data) {
        return axios.post('/api/contacto', data);
    }
};

export default api;